import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const AutoSlider = () => {
  const formations = [
    {
      title: "Hygiène et HACCP",
      description:
        "Formation sur l'hygiène et les normes HACCP pour les professionnels de la restauration et de l'industrie alimentaire.",
      image: require("../../assets/img/ValHome_Webp/Affichage.webp"),
      levels: "Débutant à intermédiaire",
      duration: "Durée a determiner selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 1200€",
      objectives: [
        "Comprendre les principes de l'hygiène alimentaire",
        "Maîtriser les normes HACCP pour la sécurité des aliments",
        "Appliquer les protocoles de sécurité dans les environnements de restauration et de production",
        "Identifier et prévenir les risques alimentaires",
      ],
      modalities: ["Présentiel", "E-learning"],
    },
    {
      title: "Langues",
      description: `La formation en langues de Valacademy Formations vous aide à améliorer vos compétences linguistiques, en couvrant la grammaire, le vocabulaire, et la communication orale et écrite, pour plusieurs langues. Adaptée à tous les niveaux, elle vous prépare à utiliser ces compétences dans des contextes professionnels et quotidiens. Les langues proposées incluent :

- Langue Anglaise  
- Langue Allemande  
- Langue Française pour les étrangers (FLE)  
- Langue Chinoise  
- Langue Japonaise  
- Langue Espagnole  
- Langue Italienne  
- Langue Arabe  
- Langue Portugaise`,
      image: require("../../assets/img/ValHome_Webp/Langue.webp"),
      levels: "Débutant à avancé",
      duration: "Durée a determiner selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 1000€",
      objectives: [
        "Acquérir des compétences en communication orale et écrite",
        "Améliorer la grammaire et la syntaxe",
        "Développer un vocabulaire adapté aux besoins professionnels",
        "Participer à des simulations d'entretiens professionnels dans différentes langues",
      ],
      modalities: ["Présentiel", "En visio", "E-learning"],
    },
    {
      title: "Coiffure et Esthétique",
      description:
        "La formation en coiffure et esthétique de Valacademy Formations vous enseigne les techniques modernes de coiffure, de maquillage, et de soins de beauté. Adaptée aux professionnels et débutants, elle vous permet de développer des compétences pratiques pour exceller dans l'industrie de la beauté.",
      image: require("../../assets/img/ValHome_Webp/Makeup.webp"),
      levels: "Débutant à avancé",
      duration: "Durée a determiner selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 1500€",
      objectives: [
        "Apprendre les techniques de coupe, coiffage et coloration",
        "Maîtriser les soins esthétiques et de la peau",
        "Développer des compétences en maquillage et soins du visage",
        "Gérer un salon de beauté et optimiser l'expérience client",
      ],
      modalities: ["Présentiel", "E-learning"],
    },
    {
      title: "CACES",
      description:
        "La formation CACES de Valacademy Formations vous prépare à l’obtention du certificat CACES, indispensable pour la conduite d'engins de chantier en toute sécurité. Elle couvre les règles de sécurité, la manipulation des équipements, et les techniques nécessaires à une conduite efficace et conforme aux normes.",
      image: require("../../assets/img/CACES (2).png"),
      levels: "Intermédiaire",
      duration: "Durée a determiner selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 800€",
      objectives: [
        "Acquérir les compétences nécessaires pour conduire des engins de chantier en toute sécurité",
        "Maîtriser les gestes techniques et la réglementation des engins",
        "Appliquer les bonnes pratiques de sécurité sur les chantiers",
      ],
      modalities: ["Présentiel"],
    },
    {
      title: "Intelligence Artificielle",
      description:
        "La formation en Intelligence Artificielle de Valacademy Formations vous initie aux concepts fondamentaux de l'IA, au machine learning et au deep learning, tout en vous permettant de manipuler des outils comme TensorFlow et Scikit-learn pour développer des modèles performants.",
      image: require("../../assets/img/ValHome_Webp/IA.webp"),
      levels: "Débutant à avancé",
      duration: "Durée a determiner selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 1500€",
      objectives: [
        "Comprendre les bases de l’intelligence artificielle et du machine learning",
        "Apprendre à entraîner et optimiser des modèles d’IA",
        "Utiliser des bibliothèques comme TensorFlow, PyTorch et Scikit-learn",
        "Appliquer l’IA à des domaines concrets : reconnaissance d’image, NLP, analyse de données",
      ],
      modalities: ["Présentiel", "En visio", "E-learning"],
    },
    // {
    //   title: "Marketing Digital",
    //   description:
    //     "La formation en marketing digital de Valacademy Formations couvre les stratégies clés du SEO, SEM, et des réseaux sociaux, vous permettant de développer des compétences pour optimiser la visibilité en ligne et gérer des campagnes marketing efficaces.",
    //   image: require("../../assets/img/ValHome_Webp/Marketing.jpg"),
    //   levels: "Intermédiaire à avancé",
    //   duration: "40h",
    //   financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
    //   price: "À partir de 1300€",
    //   objectives: [
    //     "Maîtriser les techniques de SEO et SEM",
    //     "Optimiser la visibilité d'un site web",
    //     "Gérer des campagnes publicitaires sur Google Ads et Facebook Ads",
    //     "Utiliser les réseaux sociaux pour augmenter la visibilité en ligne",
    //   ],
    //   modalities: ["Présentiel", "En visio", "E-learning"],
    // },
    {
      title: "Comptabilité",
      description:
        "La formation en Comptabilité de Valacademy Formations vous permet de maîtriser les bases de la gestion comptable, fiscale et financière. Idéale pour débuter ou renforcer vos compétences dans le domaine, elle prépare aux métiers de la comptabilité en entreprise ou en cabinet.",
      image: require("../../assets/img/ValHome_Webp/Comptabilite.webp"),
      levels: "Débutant à intermédiaire",
      duration: "Durée à déterminer selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 1500€",
      objectives: [
        "Maîtriser les principes fondamentaux de la comptabilité générale",
        "Comprendre la fiscalité des entreprises et les obligations légales",
        "Savoir établir un bilan, un compte de résultat et enregistrer les écritures comptables",
        "Utiliser des logiciels comptables courants pour automatiser les tâches",
      ],
      modalities: ["Présentiel", "E-learning"],
    },
  ];
  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade-out

      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % formations.length);
        setFade(true); // Start fade-in
      }, 500); // Fade-out duration
    }, 5000); // Total time before switching

    return () => clearInterval(interval);
  }, [formations.length]);

  const formation = formations[current];
  return (
    <div>
      <p
        style={{
          display: "flex",
          fontSize: "2em",

          fontWeight: "bold",
          justifyContent: "center",
          color: "black",
          padding: "1%",
          textShadow: "2px 2px 8px rgb(124, 50, 0)", // Corrected syntax
          paddingTop: "7%",
          paddingBottom: "7%",
          textAlign: "center",
        }}
      >
        Nos formations les plus demandées
      </p>

      <div className="relative w-full max-w-4xl mx-auto overflow-hidden rounded-xl shadow-lg">
        <div
          className={`transition-opacity duration-500 ease-in-out ${
            fade ? "opacity-100" : "opacity-0"
          }`}
          key={formation.title}
        >
          <img
            src={formation.image}
            alt={formation.title}
            className="w-full h-96 object-cover"
          />
          <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/70 to-transparent text-white px-6 py-8 text-center">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">
              {formation.title}
            </h2>
            <Link
              to="/formation"
              className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-2 rounded transition"
              state={{
                name: formation.title,
                image: formation.image,
                description: formation.description,
                reason: formation.reason,
                benefits: formation.benefits,
                details: formation.details,
                levels: formation.levels,
                duration: formation.duration,
                financing: formation.financing,
                price: formation.price,
                objectives: formation.objectives,
                modalities: formation.modalities,
              }}
            >
              Programme
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutoSlider;
